import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { sortBy } from "lodash-es";
import { useMemo } from "react";
import { useAccountLimitsContext } from "../../../../../context/account-limit-context";

import type { FC } from "react";
import "./debug.css";

export const AccountLimitsGrid: FC = () => {
  const limits = useAccountLimitsContext();

  const limitEntries = useMemo(
    () =>
      sortBy(
        Object.entries(limits).map(([key, value]) => ({ key, value: String(value) })),
        (x) => x.key,
      ),
    [limits],
  );

  return (
    <Stack spacing={1} direction="column">
      <Typography variant="h6">Details</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell align="right">Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {limitEntries.map(({ key, value }) => (
              <TableRow key={key}>
                <TableCell>{key}</TableCell>
                <TableCell align="right">{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
